export default __webpack_public_path__ + "static/media/user.24c3b1ec.svg";